<ng-container *miproLoading="loadingPatient">
    <form
        #autoSave="autoSave"
        [autoSave]="autoSavePatient"
        [useServerResponse]="false"
        [formGroup]="patientForm"
        (ngSubmit)="manualSavePatient()"
        class="m-form">
        <form-state></form-state>

        <p-messages severity="warn" *ngIf="warningText">
            <ng-template pTemplate="content">
                <div class="flex flex-column">
                    <div class="flex align-items-center mb-2">
                        <i class="pi pi-clock mr-1"> </i>
                        <b>{{ warningText }}</b>
                    </div>
                </div>
            </ng-template>
        </p-messages>

        <edit-patient-control
            [selfRegister]="currentPatient.selfRegister"
            [requiredEmail]="currentPatient.selfRegister"
            formControlName="patient">
            <ng-container formGroupName="otherFields">
                <div class="col-12">
                    <div class="inputs-group" style="max-width: 100%">
                        <div class="inputs-group-row">
                            <label class="inputs-group-row-name asterisk-mark">
                                <naming-convention-label [type]="'Group'"></naming-convention-label>:
                            </label>
                            <div class="inputs-group-row-value">
                                <organization-groups
                                    [formControl]="organizationGroups"
                                    [isRequired]="organizationGroups.value.length === 0"
                                    (organizationsChanged)="organizationsChanged($event)"></organization-groups>
                                <control-errors [control]="organizationGroups" [errors]="_errorMessages"></control-errors>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
        </edit-patient-control>

        <div class="inputs-group-row mt-3 flex justify-content-end">
            <patient-consent
                formControlName="consentToUpdate"
                [masterProfileId]="currentPatient.patientId"
                (enabledPSDConfirmationChanged)="onEnabledPSDConfirmationChanged($event)">
            </patient-consent>
        </div>

        <form-buttons allowOffline [saving]="savingPatient" [config]="buttonsConfig" [disabled]="patientForm.invalid || !consentToUpdate">
            <button
                *ngIf="enableSendPasswordResetMailBtn"
                type="button"
                pButton
                label="Password reset"
                [disabled]="savingPatient || runningUserAction"
                (click)="sendPasswordResetMail()"></button>
            <button *ngIf="isAuthenticatorEnabled && allowedToReset2Fa"
                type="button"
                pButton
                label="Reset 2FA"
                (click)="reset2FaConfirmation()"></button>
            <button
                *ngIf="enableResendInvitationBtn"
                type="button"
                pButton
                label="Resend invitation"
                [disabled]="savingPatient || runningUserAction"
                (click)="resendInvitation()"></button>
        </form-buttons>

        <div class="flex justify-content-between">
            <div class="align-items-end flex">
                <button
                    *ngIf="canApproveSelfRegistered()"
                    type="button"
                    pButton
                    class="m-button-primary"
                    [disabled]="patientForm.invalid || !this.consentToUpdate"
                    label="Save & Approve"
                    (click)="approveSelfRegisteredClicked()"></button>
            </div>
        </div>
    </form>
</ng-container>

<duplicate-patients-dialog
    [duplicates]="duplicatePatients"
    [currentPatient]="currentPatient"
    [(visible)]="duplicatesDialogVisible"
    [selfRegWalkInId]="selfRegWalkInId"
    (completed)="reloadPatient($event); duplicatesCheckCompleted($event)"></duplicate-patients-dialog>


<form-event-workflow
    [formEventType] = "formEventType"
    [returnUrl] = "returnUrl"
    [backNavigationParams]="queryParams" >
</form-event-workflow>